import React from 'react';
import { Chip } from '@mui/material';
import UnifiedTransactionTable from '../shared/UnifiedTransactionTable';
interface TransactionDetailReportProps {
  dateRange: {
    from: string;
    to: string;
  };
}
interface Transaction {
  id: string;
  date: string;
  senderName: string;
  receiverName: string;
  amount: number;
  currency: string;
  status: string;
  paymentMethod: string;
  country: string;
  agent: string;
}
const TransactionDetailReport: React.FC<TransactionDetailReportProps> = ({
  dateRange
}) => {
  // Mock data for the report
  const transactions: Transaction[] = [{
    id: 'TXN000001201921',
    date: '2023-04-15',
    senderName: 'Ahmed Al Mansouri',
    receiverName: 'Muhammad Ali',
    amount: 5000,
    currency: 'AED',
    status: 'Completed',
    paymentMethod: 'Bank Transfer',
    country: 'United Arab Emirates',
    agent: 'Al Ansari Exchange'
  }, {
    id: 'TXN000002225463',
    date: '2023-04-16',
    senderName: 'John Smith',
    receiverName: 'Asad Khan',
    amount: 3500,
    currency: 'GBP',
    status: 'Completed',
    paymentMethod: 'Cash',
    country: 'United Kingdom',
    agent: 'Western Union'
  }, {
    id: 'TXN000002225479',
    date: '2023-04-17',
    senderName: 'Michael Johnson',
    receiverName: 'Zahid Hussain',
    amount: 2800,
    currency: 'USD',
    status: 'Completed',
    paymentMethod: 'Partial',
    country: 'United States',
    agent: 'MoneyGram'
  }, {
    id: 'TXN000004478520',
    date: '2023-04-18',
    senderName: 'Abdullah Mohammad',
    receiverName: 'Rashid Ahmed',
    amount: 4200,
    currency: 'SAR',
    status: 'Completed',
    paymentMethod: 'Bank Transfer',
    country: 'Saudi Arabia',
    agent: 'UAE Exchange'
  }, {
    id: 'TXN000004478521',
    date: '2023-04-19',
    senderName: 'Mohammad Al Farsi',
    receiverName: 'Imran Khan',
    amount: 3800,
    currency: 'QAR',
    status: 'Completed',
    paymentMethod: 'Cash',
    country: 'Qatar',
    agent: 'Ria Money Transfer'
  }];
  const formatCurrency = (amount: number, currency: string) => {
    return new Intl.NumberFormat('en-US', {
      style: 'currency',
      currency: currency,
      minimumFractionDigits: 2
    }).format(amount);
  };
  const handleViewDetails = (transaction: Transaction) => {
    console.log('View transaction:', transaction.id);
    // You can implement a modal or navigation here
  };
  const columns = [{
    id: 'id',
    label: 'Transaction ID',
    filterable: true,
    filterType: 'text' as const
  }, {
    id: 'date',
    label: 'Date',
    filterable: true,
    filterType: 'date' as const
  }, {
    id: 'senderName',
    label: 'Sender',
    filterable: true,
    filterType: 'text' as const
  }, {
    id: 'receiverName',
    label: 'Receiver',
    filterable: true,
    filterType: 'text' as const
  }, {
    id: 'amount',
    label: 'Amount',
    filterable: true,
    filterType: 'number' as const,
    format: (value: number) => formatCurrency(value, 'AED')
  }, {
    id: 'country',
    label: 'Country',
    filterable: true,
    filterType: 'select' as const,
    filterOptions: ['United Arab Emirates', 'United Kingdom', 'United States', 'Saudi Arabia', 'Qatar']
  }, {
    id: 'agent',
    label: 'Agent',
    filterable: true,
    filterType: 'select' as const,
    filterOptions: ['Al Ansari Exchange', 'Western Union', 'MoneyGram', 'UAE Exchange', 'Ria Money Transfer']
  }, {
    id: 'paymentMethod',
    label: 'Payment Method',
    filterable: true,
    filterType: 'select' as const,
    filterOptions: ['Bank Transfer', 'Cash', 'Partial']
  }, {
    id: 'status',
    label: 'Status',
    filterable: true,
    filterType: 'select' as const,
    filterOptions: ['Completed', 'Pending', 'Rejected'],
    format: (value: string) => <Chip label={value} color={value === 'Completed' ? 'success' : value === 'Pending' ? 'warning' : 'error'} size="small" data-id="element-2427" />
  }];
  const totalAmount = transactions.reduce((sum, transaction) => sum + transaction.amount, 0);
  return <div data-id="element-2428">
      <div className="mb-4 p-3 bg-blue-50 border border-blue-100 rounded-md" data-id="element-2429">
        <h3 className="text-sm font-medium text-blue-800" data-id="element-2430">Report Parameters</h3>
        <p className="text-xs text-blue-600 mt-1" data-id="element-2431">
          Date Range: {dateRange.from} to {dateRange.to}
        </p>
      </div>

      <UnifiedTransactionTable columns={columns} data={transactions} onViewDetails={handleViewDetails} title="Transaction Detail Report" emptyMessage="No transactions found for the selected date range" data-id="element-2432" />

      <div className="mt-4 p-3 bg-gray-50 border border-gray-200 rounded-md" data-id="element-2433">
        <div className="flex justify-between items-center" data-id="element-2434">
          <span className="text-sm font-medium text-gray-700" data-id="element-2435">
            Total Transactions: {transactions.length}
          </span>
          <span className="text-sm font-medium text-gray-700" data-id="element-2436">
            Total Amount: {formatCurrency(totalAmount, 'USD')}
          </span>
        </div>
      </div>
    </div>;
};
export default TransactionDetailReport;